import * as actionTypes from './actionTypes';
import { stringify } from 'query-string';
import { CONSTANTS } from './constants';
import { serviceValidationReportToken, serviceRefreshToken } from './services';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

const fetchValidationReportTokenRequest = () => ({
  type: actionTypes.FETCH_VALIDATION_REPORT_TOKEN_REQUEST
});

const fetchValidationReportTokenFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_VALIDATION_REPORT_TOKEN_FAILURE,
  errorMessage
});

const fetchValidationReportTokenSuccess = (data) => ({
  type: actionTypes.FETCH_VALIDATION_REPORT_TOKEN_SUCCESS,
  data
});

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

export const fetchValidationReportToken = (url: string, queryString: object): Function => {
  return async dispatch => {
    dispatch(fetchValidationReportTokenRequest());
    try {
      const data = await serviceValidationReportToken.getData(url);
      dispatch(fetchValidationReportTokenSuccess(data));

      const reportToken = sessionStorage.getItem('reportToken');
      const filterValues = {
        ...queryString,
        token: reportToken
      };
      const valuesQueryString = stringify(filterValues);
      window.open(`${process.env.API_EXCEL}?${valuesQueryString}`);
    } catch(e) {
      if (
        e.code === CONSTANTS.notAuthorized ||
        e.code === CONSTANTS.errorValidationRole ||
        e.code === CONSTANTS.invalidReportToken ||
        e.code === CONSTANTS.reportTokenExpired
      ) {
        if (e.code === CONSTANTS.errorValidationRole) {
          queryString['userId'] = decodeAccessToken('idUser');
        }
        dispatch(fetchRefreshToken(url, queryString));
        return;
      }
      dispatch(fetchValidationReportTokenFailure(e.message));
    }
  }
};

const fetchRefreshToken = (url: string, queryString: object) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      sessionStorage.setItem('accessToken', data.accessToken);
      sessionStorage.setItem('reportToken', data.reportToken);
      dispatch(fetchValidationReportToken(url, queryString));
    } catch (error) {
      dispatch(fetchValidationReportTokenFailure(error.message));
    }
  }
}
